import React,{useContext} from 'react'
import DatePicker from "react-datepicker";

import { AppContext } from "../../../AppContext";
import UserSelectBox from "../../common/controls/UserSelectBox";

const DefaultForm = (props) =>{

    const [appContext, setAppContext] = useContext(AppContext);

    const handleNumberFieldDecimalChange = (e) => {

        if (/^\d+\.?\d{0,2}$/.test(e.target.value) || e.target.value === "") {
            let { value, min, max } = e.target;
            if(min && max && (e.target.value !== "")){
                if(Number(value)>=Number(min) && Number(value) <= Number(max))
                props.handleChange(e);
                
            } else{
              props.handleChange(e);
            }
      }
    };



    return (
        <div className="form-body">
            <div className="form-items">
                <div className="form-desc">Outside business activities (“OBA”) include all activities for which you receive any form of compensation and certain uncompensated activities that you may engage in, for example, any civic, charitable or public service group. Please attach additional information as necessary to complete your responses.</div>
                <div className="form-columns">

                    <div className="form-column">

                        <div className="form-item">
                            <label className={`form-item-label required ${props.validation.businessName ? "" : "warning"}`} htmlFor="businessName">Name of Business :</label>
                            <input
                                className="form-item-value"
                                type="text"
                                id="businessName"
                                name="businessName"
                                maxLength="200" 
                                value={props.data.businessName}
                                onChange={props.handleChange}
                                />
                        </div>

                        <div className="form-item">
                            <label className={`form-item-label required ${props.validation.businessType ? "" : "warning"}`} htmlFor="businessType">Business Type :</label>
                            <input
                                className="form-item-value"
                                type="text"
                                id="businessType"
                                name="businessType"
                                maxLength="200" 
                                value={props.data.businessType}
                                onChange={props.handleChange}
                                />
                        </div>

                        <div className="form-item">
                            <label
                                className={`form-item-label required ${props.validation.businessDesc ? "" : "warning"
                                    }`}
                                htmlFor="businessDesc"
                                >
                                Business Description :
                            </label>
                            <input
                                className="form-item-value"
                                type="text"
                                id="businessDesc"
                                name="businessDesc"
                                maxLength="500" 
                                value={props.data.businessDesc}
                                onChange={props.handleChange}
                                />
                        </div>




                        <div className="form-item">
                            <label
                                className={`form-item-label required ${props.validation.businessAddress ? "" : "warning"
                                    }`}
                                htmlFor="businessAddress"
                                >
                                Business Address :
                            </label>
                            <input
                                className="form-item-value"
                                type="text"
                                id="businessAddress"
                                name="businessAddress"
                                maxLength="500" 
                                value={props.data.businessAddress}
                                onChange={props.handleChange}
                                />
                        </div>




                        <div className="form-item">
                            <label
                                className={`form-item-label required ${props.validation.yearlyIncome ? "" : "warning"
                                    }`}
                                htmlFor="yearlyIncome"
                                >
                                Yearly Income from OBA :
                            </label>
                            <input
                                className="form-item-value"
                                type="number"
                                id="yearlyIncome"
                                name="yearlyIncome"
                                min="0"
                                max="9999999999"
                                value={props.data.yearlyIncome}
                                onChange={handleNumberFieldDecimalChange}
                                />
                        </div>
                    </div>

                    <div className="form-column">

                        <div className="form-item">
                            <label
                                className={`form-item-label required ${props.validation.compensationMethod ? "" : "warning"
                                    }`}
                                htmlFor="compensationMethod"
                                >
                                Compensation Method :
                            </label>
                            <input
                                className="form-item-value"
                                type="text"
                                id="compensationMethod"
                                name="compensationMethod"
                                maxLength="200" 
                                value={props.data.compensationMethod}
                                onChange={props.handleChange}
                                />
                        </div>


                        <div className="form-item">
                            <label
                                className={`form-item-label required ${props.validation.engagementTime ? "" : "warning"
                                    }`}
                                htmlFor="engagementTime"
                                >
                                Engagement % of Time :
                            </label>
                            <input
                                className="form-item-value"
                                type="number"
                                id="engagementTime"
                                name="engagementTime"
                                value={props.data.engagementTime}
                                onChange={handleNumberFieldDecimalChange}
                                min="1"
                                max="100"
                                />
                        </div>

                        <div className="form-item">
                            <label
                                className={`form-item-label required ${props.validation.activityStartDate ? "" : "warning"
                                    }`}
                                htmlFor="activityStartDate"
                                >
                                Activity Start Date :
                            </label>
                            <div className="form-item-value">
                                <DatePicker
                                    selected={props.data.activityStartDate}
                                    onChange={props.handleDateChange}
                                />
                            </div>
                        </div>

                    </div>

                </div>
                <div className="form-columns mt-4">
                    <div className="form-column">
                        <div className="form-item">
                            <label className={`form-item-label wrap required ${props.validation.businessCustody ? "" : "warning" }`} htmlFor="businessCustody">Do you have custody or control over the funds or property of others in connection with the is OBA? (e.g. trustee powers, fund raising, check writing authority, treasurer position, payment by retainer) :</label>
                        </div>
                    </div>
                    <div className="form-column">
                        <div className="form-item">

                            <div className="form-item-value">
                                <div className="full-width label-group">
                                    <label>
                                        <input type="radio" name="isBusinessCustody" value="No" className="form-check-input" checked={props.data.isBusinessCustody === "No"} onChange={props.handleChange}/>
                                        No
                                    </label>
                                    
                                    <label>
                                        <input type="radio" name="isBusinessCustody" value="Yes" className="form-check-input" checked={props.data.isBusinessCustody === "Yes"} onChange={props.handleChange}/>
                                        Yes
                                    </label>
                                    <label>(If Yes, please specify)</label>
                                </div>
                                <textarea rows="3" className="full-width" id="businessCustody" name="businessCustody" maxLength="200" disabled={props.data.isBusinessCustody !== 'Yes'} value={props.data.businessCustody} onChange={props.handleChange}/>
                            </div>
                        </div>
                    </div>

                </div>



                <div className="form-columns mt-4">
                    <div className="form-column">
                        <div className="form-item">
                            <label className={`form-item-label required ${props.validation.businessStructure ? "" : "warning" }`} htmlFor="businessStructure">
                            Structure of the organization :
                            </label>
                            <label className="form-item-desc">List the owners, dollar amount invested, entity type (Corporation, LLC, etc.), relationship to you and percent of ownership (must equal 100%) </label>
                        </div>
                    </div>

                    <div className="form-column">
                        <div className="form-item">
                            <textarea rows="3" className="full-width" id="businessStructure" name="businessStructure" maxLength="1024" value={props.data.businessStructure} onChange={props.handleChange}/>
                        </div>

                    </div>
                </div>

                <div className="form-columns mt-4">
                    <div className="form-column"></div>
                    <div className="form-column">

                        <div className="form-item">
                            <label className="form-item-label" htmlFor="attachment">Attachment Document :</label>
                            <div className="form-item-value placeholder">
                                <input type="file" name="attachment" id="attachment" onChange={props.handleChange}/>
                            </div>
                        </div>

                        <div className="form-item">
                            {appContext.user.submitOnBehalf && props.editorMode === 'NEW' &&
                                <UserSelectBox label='Submit On Behalf of : ' styleClass='mt-3rem' onSelected={props.handleChange} name='submittedFor' value={() => { return props.data.submittedFor ? { value: props.data.submittedFor, label: props.data.submittedForLabel } : null }} />
                            }
                        </div>

                    </div>
                </div>

            </div>
        </div>
    )
  };

export default DefaultForm;
